import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { AuthService } from 'src/app/_services/auth.service';
import _Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';


@Component({
  selector: 'tangram-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {
  iconPath = appConfig.iconPath;
  @Input() playlist: any;
  @Input() isMediaCompleted: boolean = false;
  @Input() showCompletionCheckbox: boolean = false;
  // In draft mode the stat icons (views, users, rating, comments) are hidden
  // so the playlist row only shows the delete action next to the media meta.
  @Input() isDraft: boolean = false;
  @Output() onChangePlaylist = new EventEmitter();
  @Output() deleteMediaFromPlayList = new EventEmitter();
  @Output() onToggleMediaCompletion = new EventEmitter();
  previewVideoThumbnail: string = "assets/img/videos/img6.png"; // To store image url
  currentUser: any;
  currentMedia : string = ''
  mediaAverageRating: number = 0;

  // Description expansion — long playlist descriptions clamp to 3 lines
  // with a "View more" toggle so every card stays roughly the same height.
  isDescExpanded: boolean = false;

  /**
   * Length threshold above which we render a "View more" link. Picked to
   * roughly correspond to ~3 lines at the card's body width — anything
   * shorter never wraps past the clamp anyway, so the toggle is hidden.
   */
  get isDescLong(): boolean {
    const desc = (this.playlist && this.playlist.description) ? String(this.playlist.description) : '';
    return desc.length > 160;
  }

  toggleDescription(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.isDescExpanded = !this.isDescExpanded;
  }

  /**
   * Bucket the playlist item into one of the six visual media types we
   * style for in the right-rail card. Falls back to 'video' so a brand-new
   * playlist row still gets a tone class (instead of being unstyled).
   * Uses non-optional-chaining syntax to stay compatible with the project's
   * TypeScript version.
   */
  get mediaTypeKey(): 'video' | 'audio' | 'pdf' | 'webpage' | 'image' | 'document' {
    const pl = this.playlist || {};
    const tag = pl.tag || {};
    const tagName = (tag.name || '').toString().toLowerCase();
    const title = (pl.title || '').toString().toLowerCase();
    const url = (pl.videoURL || pl.url || '').toString().toLowerCase();
    const haystack = tagName + ' ' + title + ' ' + url;
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)(\?|$)/.test(url) || /photo|image|picture/.test(tagName)) return 'image';
    if (/\.pdf(\?|$)/.test(url) || /pdf/.test(haystack)) return 'pdf';
    if (/audio|podcast|spotify|soundcloud|\.(mp3|wav|m4a|ogg)(\?|$)/.test(haystack)) return 'audio';
    if (/document|article|\.(doc|docx|txt|md)(\?|$)/.test(haystack)) return 'document';
    if (/web|webpage|wiki|http/.test(haystack) && !/youtube|vimeo|video/.test(tagName)) return 'webpage';
    return 'video';
  }

  get mediaTypeLabel(): string {
    const map: { [k: string]: string } = {
      video: 'Video',
      audio: 'Audio',
      pdf: 'PDF',
      webpage: 'Webpage',
      image: 'Image',
      document: 'Document'
    };
    const pl = this.playlist || {};
    const tag = pl.tag || {};
    return map[this.mediaTypeKey] || tag.name || 'Content';
  }

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService,
    private modalService: NgbModal,
    private alertModalService: AlertModalService,
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.loadMediaRating();
  }

  loadMediaRating() {
    // The per-media rating average is public — load it for logged-out viewers
    // too (the backend GET is optional-auth). Only a valid media id is required.
    if (!this.playlist || !this.playlist._id) return;
    this.dashboardService.getMediaStarRating(this.playlist._id).subscribe((response: any) => {
      if (response.success) {
        this.mediaAverageRating = response.data.averageRating || 0;
      }
    });
  }
  toggleCompletion(event: any) {
    const isCompleted = event.target.checked;
    this.isMediaCompleted = isCompleted; // Update local state immediately
    this.onToggleMediaCompletion.emit({ videoId: this.playlist._id, isCompleted });
  }

  onPlaylistClick(playlist,event) {
    const targetElement = event.target
    if(targetElement.classList.contains('delete-btn')){
      return;
    }
    this.onChangePlaylist.emit(playlist);
  }
  
  showPopup(mediaId) {
    this.currentMedia = mediaId;
    this.alertModalService.confirm({
      title: 'Delete Media',
      message: 'Do you want to delete this media ?',
      cancelText: 'No',
      confirmText: 'Yes, Delete',
    }).subscribe(confirmed => { if (confirmed) this.deleteMedia(); });
  }

  deleteMedia(){
    this.deleteMediaFromPlayList.emit(this.currentMedia)
    this.currentMedia = ''
  }

}
